import { createSlice } from '@reduxjs/toolkit'
import { hcpcsCodeType } from '../types/hcpcsCode.types'

const initialState: hcpcsCodeType = {
  content: [],
  selected: null,
  totalPages: null,
}

const hcpcsCodeSlice = createSlice({
  name: 'hcpcsCode',
  initialState: initialState,
  reducers: {
    updateHcpcsData: (state, action) => {
      state.content = action.payload
    },
    updateTotalPagesHcpcs: (state, action) => {
      state.totalPages = action.payload
    },
    updateSelectedHcpcs: (state, action) => {
      state.selected = action.payload
    },
    resetSelectedHcpcs: (state) => {
      state.selected = null
    },
    getHcpcsDataBySortAction: () => {
      return
    },
    createHcpcsCodeAction: () => {
      return
    },
    getAllHcpcsCodeAction: () => {
      return
    },
    fetchHcpcsCodeAction: () => {
      return
    },
    updateHcpcsCodeByIdAction: () => {
      return
    },
    patchToggleUpdateDisableActionHcpcsCode: () => {
      return
    },
    patchToggleUpdateEnableActionHcpcsCode: () => {
      return
    },
    patchToggleUpdateBulkDisableActionHcpcsCode: () => {
      return
    },
    patchToggleUpdateBulkEnableActionHcpcsCode: () => {
      return
    },
  },
})

export const {
  getHcpcsDataBySortAction,
  updateTotalPagesHcpcs,
  updateHcpcsData,
  updateSelectedHcpcs,
  resetSelectedHcpcs,
  getAllHcpcsCodeAction,
  createHcpcsCodeAction,
  fetchHcpcsCodeAction,
  updateHcpcsCodeByIdAction,
  patchToggleUpdateDisableActionHcpcsCode,
  patchToggleUpdateEnableActionHcpcsCode,
  patchToggleUpdateBulkDisableActionHcpcsCode,
  patchToggleUpdateBulkEnableActionHcpcsCode,
} = hcpcsCodeSlice.actions
export default hcpcsCodeSlice.reducer
